import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

const QuickSendHeader: React.FC = () => {
  const { t } = useTranslation('quicksend');

  return (
    <header className="w-full bg-white/95 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 h-[68px] flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5">
          <img
            src="/vivosign-icon.svg"
            alt="VivoSign"
            className="h-9 w-9"
          />
          <span className="text-xl font-bold text-navy tracking-tight hidden sm:inline">
            VivoSign
          </span>
        </a>
        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <a
            href="/login"
            className="text-sm font-medium text-gray-600 hover:text-navy px-3 py-2 rounded-md hover:bg-gray-100 transition-all hidden sm:inline-flex"
          >
            {t('sign_in', 'Sign In')}
          </a>
          <a
            href="/join"
            className="text-sm font-semibold bg-green text-white px-5 py-2.5 rounded-lg hover:bg-green-dark transition-all hover:-translate-y-px shadow-sm hover:shadow-md hidden sm:inline-flex"
          >
            {t('get_started', 'Get Started Free')}
          </a>
        </div>
      </div>
    </header>
  );
};

export default QuickSendHeader;
